// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qKYtq1 {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}

.d2_UxJ {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
}

.Xe56hQ {
  border: none;
  background: none;
  color: var(--text-primary-medium, #d64000);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-sm);
  line-height: var(--line-height-120);
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s ease;
  display: flex;
  align-items: center;
}

.Xe56hQ:hover {
  color: var(--text-primary-medium, #d64000);
  text-decoration: underline;
}

.Xe56hQ:disabled,
.Xe56hQ.c24Cf9 {
  color: var(--stroke-neutral-silver, #cccccc) !important;
  cursor: not-allowed;
  pointer-events: none;
}

.qKYtq1 .Xe56hQ.c24Cf9,
.qKYtq1 a.Xe56hQ.c24Cf9,
div.qKYtq1 a.Xe56hQ.c24Cf9 {
  color: var(--stroke-neutral-silver, #cccccc) !important;
}

.ioFXWz {
  margin-left: var(--spacing-1);
}

.vLhMg2 {
  width: 14px;
  height: 15px;
  margin-left: var(--spacing-1);
  flex-shrink: 0;
  filter: brightness(0) saturate(100%) invert(42%) sepia(93%) saturate(1352%) hue-rotate(360deg) brightness(119%)
    contrast(119%);
  transition: filter 0.2s ease;
}

.rmgy7F {
  width: 14px;
  height: 15px;
  margin-left: var(--spacing-1);
  flex-shrink: 0;
  filter: brightness(0) saturate(100%) invert(42%) sepia(93%) saturate(1352%) hue-rotate(360deg) brightness(119%)
    contrast(119%);
  transition: filter 0.2s ease;
}

.Xe56hQ.c24Cf9 .vLhMg2,
.Xe56hQ:disabled .vLhMg2,
.qKYtq1 .Xe56hQ.c24Cf9 .vLhMg2,
.Xe56hQ.c24Cf9 .rmgy7F,
.Xe56hQ:disabled .rmgy7F,
.qKYtq1 .Xe56hQ.c24Cf9 .rmgy7F {
  filter: none;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/RechargeDetailsModal/components/InvoiceButton/InvoiceButton.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,0CAA0C;EAC1C,oCAAoC;EACpC,sCAAsC;EACtC,8BAA8B;EAC9B,mCAAmC;EACnC,qBAAqB;EACrB,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;;EAEE,uDAAuD;EACvD,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;;EAGE,uDAAuD;AACzD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,cAAc;EACd;kBACgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,cAAc;EACd;kBACgB;EAChB,4BAA4B;AAC9B;;AAEA;;;;;;EAME,YAAY;AACd","sourcesContent":[".container {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.invoiceText {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n}\n\n.viewLink {\n  border: none;\n  background: none;\n  color: var(--text-primary-medium, #d64000);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-medium);\n  font-size: var(--font-size-sm);\n  line-height: var(--line-height-120);\n  text-decoration: none;\n  cursor: pointer;\n  transition: color 0.2s ease;\n  display: flex;\n  align-items: center;\n}\n\n.viewLink:hover {\n  color: var(--text-primary-medium, #d64000);\n  text-decoration: underline;\n}\n\n.viewLink:disabled,\n.viewLink.disabled {\n  color: var(--stroke-neutral-silver, #cccccc) !important;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.container .viewLink.disabled,\n.container a.viewLink.disabled,\ndiv.container a.viewLink.disabled {\n  color: var(--stroke-neutral-silver, #cccccc) !important;\n}\n\n.count {\n  margin-left: var(--spacing-1);\n}\n\n.arrow {\n  width: 14px;\n  height: 15px;\n  margin-left: var(--spacing-1);\n  flex-shrink: 0;\n  filter: brightness(0) saturate(100%) invert(42%) sepia(93%) saturate(1352%) hue-rotate(360deg) brightness(119%)\n    contrast(119%);\n  transition: filter 0.2s ease;\n}\n\n.arrowIcon {\n  width: 14px;\n  height: 15px;\n  margin-left: var(--spacing-1);\n  flex-shrink: 0;\n  filter: brightness(0) saturate(100%) invert(42%) sepia(93%) saturate(1352%) hue-rotate(360deg) brightness(119%)\n    contrast(119%);\n  transition: filter 0.2s ease;\n}\n\n.viewLink.disabled .arrow,\n.viewLink:disabled .arrow,\n.container .viewLink.disabled .arrow,\n.viewLink.disabled .arrowIcon,\n.viewLink:disabled .arrowIcon,\n.container .viewLink.disabled .arrowIcon {\n  filter: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `qKYtq1`,
	"invoiceText": `d2_UxJ`,
	"viewLink": `Xe56hQ`,
	"disabled": `c24Cf9`,
	"count": `ioFXWz`,
	"arrow": `vLhMg2`,
	"arrowIcon": `rmgy7F`
};
module.exports = ___CSS_LOADER_EXPORT___;
